<template>
    <div class="cwjr" @click="hideMobileMenu">
        <DepartmentHeader ref="myHeader"></DepartmentHeader>
        <div class="d_content">
            <div class="content_box">
                <div class="left_menu_box">
                    <DepartmentLeftMenu></DepartmentLeftMenu>
                </div>
                <div class="right_content_box">
                    <div class="right_content_box_detail" style="">
                        <div style="height:40px;line-height:40px;border-bottom:solid 1px #eeeeee;overflow: hidden;"> <a href="https://www.fdsm.fudan.edu.cn/AboutUs/index.aspx" target="_blank">学院首页</a> > 系科设置  > {{departmentName}} > {{pageTitle}}</div>
                        <div style="margin-top:20px;"><router-view/></div>
                    </div>
                </div>
                <div class="d_clear"></div>
            </div>
        </div>
        <DepartmentFooter></DepartmentFooter>
    </div>
</template>

<script>
// @ is an alias to /src
import DepartmentHeader from '@/components/DepartmentHeader.vue'
import DepartmentLeftMenu from '@/components/DepartmentLeftMenu.vue'
import DepartmentFooter from '@/components/DepartmentFooter.vue'
export default {
  data () {
    return {
    }
  },
  computed: {
    departmentName: function () {
      return this.$store.state.CurrDepartName
    },
    pageTitle: function () {
      return this.$store.state.CurrPageTitle
    }
  },
  components: {
    DepartmentHeader,
    DepartmentLeftMenu,
    DepartmentFooter
  },
  methods: {
    hideMobileMenu: function () {
      this.$refs.myHeader.show = false
    }
  }
}
</script>
